"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgNurseOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M16 16c4 0 6 1.333 6 4 0 1.333-.667 2-2 2H4c-1.333 0-2-.667-2-2 0-2.667 2.001-4 6.004-4H16zm0 2H8c-2.667 0-4 .667-4 2h16c0-1.333-1.333-2-4-2zM11.998 2c1.76 0 3.522.258 5.283.775a1 1 0 01.719.96V9.6a1 1 0 01-1 1h-.018l-.035-.001c0 1.174-1.434 4.4-4.95 4.4-3.422 0-4.873-3.085-4.947-4.305l-.003-.095A.989.989 0 016 9.613V3.734a1 1 0 01.718-.96A18.655 18.655 0 0111.998 2zM12 10c-1.64 0-2.99.248-2.99.265a3 3 0 005.979-.017S13.64 10 12 10zm-.024-6c-1.17 0-2.332.133-3.484.4L8 4.521V8.5a16.47 16.47 0 014.002-.5c1.167 0 2.333.128 3.499.383L16 8.5V4.522A15.991 15.991 0 0011.977 4zm.523.5v1.002l1.004.002v.998H12.5V7.5h-1v-.998h-1.002v-.998H11.5V4.5h1z' }))); };
exports.default = SvgNurseOutline;
//# sourceMappingURL=NurseOutline.js.map